﻿let timer = null

export function show(message: string, error: boolean = false) {
    $('#bcfla-msg-text').html(message)

    $('#bcfla-msg').addClass('open')

    if (error) $('#bcfla-msg').addClass('err')
    else $('#bcfla-msg').removeClass('err')

    if (error) $('#bcfla-msg-icon').attr('class', 'glyphicon glyphicon-exclamation-sign')
    else $('#bcfla-msg-icon').attr('class', 'glyphicon glyphicon-info-sign')

    if (!error) {
        if (timer) clearTimeout(timer)

        timer = setTimeout(function () {
            hide()
        }, 3000)
    }
}

export function showError(message: string) {
    show(message, true)
}

export function hide() {
    $('#bcfla-msg-text').html('')
    $('#bcfla-msg').removeClass('open')
}
